<!-- Spacer -->
<div
    class="fuse-vertical-navigation-item-wrapper"
    [ngClass]="$safeNavigationMigration(item.classes?.wrapper)"></div>
